import { render, staticRenderFns } from "./auto-process.vue?vue&type=template&id=57d2510c&scoped=true&"
import script from "./auto-process.vue?vue&type=script&lang=js&"
export * from "./auto-process.vue?vue&type=script&lang=js&"
import style0 from "./auto-process.vue?vue&type=style&index=0&id=57d2510c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d2510c",
  null
  
)

export default component.exports